import { useQuery } from "@tanstack/react-query";
import type {
  AtAGlanceBucketSize,
  AtAGlanceResponse,
} from "@insights/contracts";
import { api } from "../../../api";

export type ActivityFilters = {
  bucketSize: AtAGlanceBucketSize;
  repository: string;
  teamId: string;
  contributor: string;
};

function activityQueryString(filters: ActivityFilters) {
  const query = new URLSearchParams({ bucket: filters.bucketSize });

  if (filters.repository) {
    query.set("repository", filters.repository);
  }
  if (filters.teamId) {
    query.set("teamId", filters.teamId);
  }
  if (filters.contributor) {
    query.set("contributor", filters.contributor);
  }

  return query;
}

export function useAtAGlance(
  workspaceId: string | undefined,
  filters: ActivityFilters,
) {
  return useQuery({
    enabled: Boolean(workspaceId),
    queryKey: ["at-a-glance", workspaceId, filters],
    queryFn: () =>
      api<AtAGlanceResponse>(
        `/${workspaceId}/at-a-glance?${activityQueryString(filters)}`,
      ),
  });
}
